module.exports = __webpack_public_path__ + "static/media/21-3.0abc4ecd.mp3";